import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import classes from "./ResourceEdit.scss";
import I18nHOC from "UIComponents/I18nHOC";
import Transition from "UIComponents/Transition";
import MarkdownView from "UIComponents/MarkdownView";
import Header from "UnitPlans/components/LibraryCommonComponents/Header";
import MiddlePane from "./components/MiddlePane";
import {
  removeAssessmentTool,
  updateAssessmentInRedux,
  updateShowAIQuickTip,
  updateAIDataInRedux,
} from "Assessments/modules/AssessmentModule";
import {
  createAttachment,
  deleteAttachment,
  createAttachmentGroups,
  deleteAttachmentGroups,
} from "modules/Services";
import { updateField } from "modules/FieldUpdateThunks";
import { delay, getCountString } from "Utils";
import {
  toggleFocusedField,
  TYPE_TO_BLUR_FIELD_EVENTS_MAPPING,
} from "modules/PusherModule";
import {
  enityEnumToLocalTypeMapping,
  ResourceDetailsContext,
  isUnitPlanEditPermission,
} from "UnitPlans/modules/UnitPlanModule";
import { validateAIEvaluationEligibility } from "ClassRoom/modules/ClassRoomModule";
import { getHelpTextLabel } from "IBPlanner/modules/IBPlannerModule";
import ScreenBaseComponent from "AppComponents/ScreenBaseComponent";
import { colors, BlurFieldEvent } from "Constants";
import { setToastMsg } from "Login/modules/LoginModule/LoginActions";
import { compose } from "lib/apolloClient";
import CommentBoxV2 from "AppComponents/CommentBoxV2";
import CoachMarks from "AppComponents/CoachMarks";
import CommentBox from "AppComponents/CommentBox";
import AITutorChatModal from "AppComponents/AITutorChatModal";
import PlannerOverviewV2 from "UnitPlans/components/PlannerOverviewV2";
import PlannerOverview from "UnitPlans/components/PlannerOverview";
import ACLStore from "lib/aclStore";
import { getIsFromClassroom } from "UnitPlans/modules/Utils";
import {
  updateAssessmentTemplate,
  getFieldValue,
} from "Assessments/modules/Utils";
import { LESSON_PLANNING_TRANSITION_PROPS } from "Assessments/modules/Constants";
import HelperPane from "IBPlanner/routes/PlannerStep/components/HelperPane";
import {
  getIsLessonPlanningEnabled,
  getShowLessonPlanningAIByDefault,
} from "ClassRoom/modules/utils";
import LessonPlanningAssistant from "ClassRoom/components/AddAssignment/LessonPlanningAssistant";
import CompactUIFooter from "ClassRoom/components/AddAssignment/CompactUIFooter";
import {
  getCurrentCurriculumProgramType,
  getSelectedAcademicYearId,
  getSelectedCurriculumId,
  getSelectedCurriculumProgram,
  getUserType,
} from "modules/CommonSelectors";
import {
  CURRICULUM_VARIANT_TODDLE_PLAY,
  TODDLE_LIBRARY,
  ASSESSMENT_TYPE_AI_TUTOR,
  ASSESSMENT_TYPE_WORKSHEET,
  TASK_TYPE_AI_TUTOR,
  TASK_TYPE_WORKSHEET,
} from "Constants/stringConstants";
import { DSProvider, Modal, Button } from "@toddle-edu/ds-web";
import {
  updateQueryParameters,
  updateNavigationObject,
} from "modules/NavigationModule";
import {
  getIsCourseBasedGradingEnabled,
  getIsLearningCoursesEnabled,
} from "LearningCourses/modules/Utils";
import { USE_NEW_GRADING_SETUP_IN_COURSE_PERM } from "Constants/permissionConstants";
import { getIsConfigurationEnabledForCPAY } from "modules/PermissionModule";
import { isSinglePageAndNewUnitView } from "UnitPlans/modules/UnitViewModeUtils";

const initialStudentPreviewConversation = {
  node: { entitySubType: "STUDENT_PREVIEW" },
};

class ResourceEdit extends ScreenBaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      showAssistantRightPane:
        getShowLessonPlanningAIByDefault() &&
        !this.props.renderAsComponent && // show Assistant by default when not rendering through AddAssignment
        this.props.curriculumProgramVariant !== CURRICULUM_VARIANT_TODDLE_PLAY, // lesson planning not available for toddle play
      middlePaneRef: null,
      missingCriteriaModalData: {},
      isGeneratingAIResponse: false,
    };

    props.customRef(this);
    this.middlePane = null;
  }

  UNSAFE_componentWillMount = () => {
    const {
      updateAssessmentInRedux,
      updateShowAIQuickTip,
      assessmentId,
    } = this.props;

    updateAssessmentInRedux({ assessmentId });
    updateShowAIQuickTip(true);
  };

  componentDidMount = () => {
    const {
      parentType,
      location,
      assessmentType,
      openAIAssistantOnMount,
      initialAiPrompt,
      showAssessmentCommentBox,
      taskTypeGroup,
    } = this.props;
    const target = _.get(location, "query.target");

    // in AI tutor assignment if ?target=sp then open student preview modal
    if (
      target === "sp" &&
      (assessmentType === ASSESSMENT_TYPE_AI_TUTOR ||
        taskTypeGroup === TASK_TYPE_AI_TUTOR)
    ) {
      this.toggleAITutorStudentPreviewModal();
    }

    this.event =
      TYPE_TO_BLUR_FIELD_EVENTS_MAPPING[
        enityEnumToLocalTypeMapping[parentType]
      ];

    BlurFieldEvent.on(this.event, this.blurFields);

    // if we come from unit flow, open right pane with AI
    const isAIAssistantEnabled = getIsLessonPlanningEnabled(
      assessmentType,
      taskTypeGroup
    );

    if (
      isAIAssistantEnabled &&
      openAIAssistantOnMount &&
      !_.isEmpty(initialAiPrompt)
    ) {
      this.setState(prevState => {
        return {
          ...prevState,
          showAssistantRightPane: true,
        };
      });
    }

    if (!_.isNil(showAssessmentCommentBox)) {
      this.doNotificationTask();
    }
  };

  componentDidUpdate = (_prevProps, prevState) => {
    const { onCommentActiveChange } = this.props;
    const wasCommentActive = prevState.currentRightPane === "comment";
    const isCommentActive = this.state.currentRightPane === "comment";
    if (wasCommentActive !== isCommentActive) {
      onCommentActiveChange?.(isCommentActive);
    }
  };

  doNotificationTask = () => {
    const { showAssessmentCommentBox, updateNavigationObject } = this.props;
    if (showAssessmentCommentBox) {
      this.onCommentClick();
    }

    updateNavigationObject({ showAssessmentCommentBox: null });
  };

  componentWillUnmount = () => {
    BlurFieldEvent.off(this.event, this.blurFields);
    if (this.state.currentRightPane === "comment") {
      this.props.onCommentActiveChange?.(false);
    }
  };

  blurFields = params => {
    if (this.middlePane) {
      this.middlePane.blurFields(params);
    }
  };

  checkValidation = async (showToast = true) => {
    const {
      validateAIEvaluationEligibility,
      t,
      resourceId,
      resourceFields,
    } = this.props;

    const totalErrors = this.middlePane.isValid();

    if (totalErrors != 0 && showToast) {
      const countText = getCountString({
        count: totalErrors,
        singularText: "error",
        pluralText: "errors",
      });
      this.props.setToastMsg({
        msg: `toastMsgs:rectify_errors_with_count`,
        locale_params: [
          { key: "count", value: totalErrors, isPlainText: true },
        ],
        position: "toast-top-center",
        type: "warning",
        fill: colors.yellow500,
      });
    }

    if (totalErrors == 0) {
      const {
        isValid: isAIEvaluationEligible,
        title: aiEvaluationErrorTitle,
        description: aiEvaluationErrorDescription,
      } = await validateAIEvaluationEligibility({
        t,
        assessmentDetails: {
          id: resourceId,
          allFields: resourceFields,
        },
      });

      if (!isAIEvaluationEligible) {
        this.setState({
          missingCriteriaModalData: {
            title: aiEvaluationErrorTitle,
            description: aiEvaluationErrorDescription,
          },
        });
        return false;
      }
    }

    return totalErrors == 0;
  };

  onClickSave = async () => {
    const {
      assessmentType,
      aiTutorSelectedTab,
      updateAIDataInRedux,
      taskTypeGroup,
    } = this.props;

    // we switch to "Tutor configuration" tab when user is in "Create with AI" tab and assign is clicked
    // else error toast is shown
    if (
      (assessmentType === ASSESSMENT_TYPE_AI_TUTOR ||
        taskTypeGroup === TASK_TYPE_AI_TUTOR) &&
      aiTutorSelectedTab === "CHAT"
    ) {
      updateAIDataInRedux({ aiTutorSelectedTab: "TASK_DETAILS" });
      setTimeout(async () => {
        const isValid = await this.checkValidation();
        if (isValid) this.props.onClose({ onlyExit: false });
      }, 100);
    } else {
      const isValid = await this.checkValidation();

      if (isValid) this.props.onClose({ onlyExit: false });
    }
  };

  onBack = async () => {
    const {
      mode,
      assessmentType,
      aiTutorSelectedTab,
      updateAIDataInRedux,
    } = this.props;

    if (mode == "edit") {
      if (
        assessmentType === ASSESSMENT_TYPE_AI_TUTOR &&
        aiTutorSelectedTab === "CHAT"
      ) {
        updateAIDataInRedux({ aiTutorSelectedTab: "TASK_DETAILS" });
        await delay(100); // slight delay so such validation is checked only once tab is switched
      }

      const isValid = await this.checkValidation();

      if (isValid) {
        this.props.onClose({ onlyExit: true });
      }
    } else {
      this.props.onClose({ onlyExit: true });
    }
  };

  toggleFocusedField = params => {
    const { parentType, toggleFocusedField } = this.props;
    toggleFocusedField({
      ...params,
      type: enityEnumToLocalTypeMapping[parentType],
    });
  };

  renderMissingCriteriaModal = ({ t }) => {
    const { title, description } = this.state.missingCriteriaModalData || {};
    const closeMissingCriteriaModal = () => {
      this.setState({
        missingCriteriaModalData: {},
      });
    };

    return (
      <Modal
        width="420px"
        height="fit-content"
        isOpen={!_.isEmpty(this.state.missingCriteriaModalData)}
        onClose={closeMissingCriteriaModal}
        dsVersion="2.0"
      >
        <Modal.Header title={title} isClosable={true} />
        <Modal.Body>
          <MarkdownView
            content={description}
            contentContainerClass={classes.markdownView}
          />
        </Modal.Body>
        <Modal.Footer>
          <div className={classes.footer}>
            <Button
              size="medium"
              onClick={closeMissingCriteriaModal}
              dsVersion="2.0"
              variant="neutral"
              type="outlined"
            >
              {t("common:back_to_editing")}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  };

  createAttachment = ({ attachment, fieldId }) => {
    const { createAttachment, portalType } = this.props;

    createAttachment({
      attachment,
      nodeId: fieldId,
      type: "PLANNER_FIELD",
      parentType: "FIELD",
      portalType,
    });
  };

  deleteAttachment = ({ attachmentId, fieldId }) => {
    const { deleteAttachment } = this.props;
    deleteAttachment({
      attachmentId,
      nodeId: fieldId,
      type: "PLANNER_FIELD",
    });
  };

  setMiddlePaneRef = ref => {
    const { assessmentType, taskTypeGroup } = this.props;

    if (
      assessmentType === ASSESSMENT_TYPE_AI_TUTOR ||
      taskTypeGroup === TASK_TYPE_AI_TUTOR
    ) {
      this.setState({ middlePaneRef: ref });
    }

    this.middlePane = ref;
  };

  onUnitSummaryClick = () => {
    this.handleRightPane({ rightPane: "unitSummary" });
  };

  onCommentClick = () => {
    this.handleRightPane({ rightPane: "comment" });
  };

  onHelpClick = ({ helperTextId, id, fieldKey }) => {
    this.handleRightPane({ rightPane: "help", id, helperTextId, fieldKey });
  };

  getRightPaneComponent = () => {
    const {
      resourceId,
      parentType,
      template,
      unitPlanId,
      helpEnabledFields,
    } = this.props;
    const { currentRightPane } = this.state;

    switch (currentRightPane) {
      case "comment":
        return (
          <ResourceDetailsContext.Consumer>
            {resourceDetails => {
              return ACLStore.can("FeatureFlag:ProjectCommentBox") ? (
                // TODO: remove when chatbar supports DS 2.0
                <DSProvider dsVersion="1.0">
                  <CommentBoxV2
                    parentType={parentType}
                    nodeId={resourceId}
                    type={parentType}
                    commentBoxContainerStyle={{ minHeight: 70 }}
                    onClose={this.onCommentClick}
                    unitPlanId={unitPlanId}
                    collaborators={_.get(
                      resourceDetails,
                      "unitPlan.collaborators",
                      []
                    )}
                  />
                </DSProvider>
              ) : (
                <CommentBox
                  parentType={parentType}
                  nodeId={resourceId}
                  type={parentType}
                  headerStyle={{ border: "none" }}
                  feedStyle={{ paddingTop: 0 }}
                  commentBoxContainerStyle={{ minHeight: 70 }}
                  onClose={this.onCommentClick}
                  unitPlanId={unitPlanId}
                  collaborators={_.get(
                    resourceDetails,
                    "unitPlan.collaborators",
                    []
                  )}
                />
              );
            }}
          </ResourceDetailsContext.Consumer>
        );
      case "unitSummary":
        return isSinglePageAndNewUnitView() ? (
          <PlannerOverviewV2
            unitPlanId={unitPlanId}
            onClose={this.onUnitSummaryClick}
            testId={"assessment-resourceEdit-plannerOverview"}
          />
        ) : (
          <PlannerOverview
            unitPlanId={unitPlanId}
            onClose={this.onUnitSummaryClick}
          />
        );
      case "help":
        return (
          <HelperPane
            fieldKey={this.state.fieldKey}
            helperTextId={this.state.helperTextId}
            onClose={this.closeRightPane}
            label={getHelpTextLabel({
              uid: this.state.fieldKey,
              template: { body: template, helpEnabledFields },
            })}
          />
        );
    }
    return null;
  };

  createAttachmentGroups = params => {
    const { createAttachmentGroups, portalType } = this.props;

    createAttachmentGroups({
      input: {
        parentId: params.parentId,
        parentType: params.parentType,
        attachments: params.attachments,
      },
      portalType,
    });
  };

  deleteAttachmentGroups = params => {
    const { deleteAttachmentGroups } = this.props;

    if (!_.isEmpty(_.get(params, "attachmentGroupIds", [])))
      deleteAttachmentGroups({ attachmentGroupIds: params.attachmentGroupIds });
  };

  toggleAssignmentAIChat = () => {
    this.setState(prevState => {
      return {
        ...prevState,
        showAssistantRightPane: !prevState.showAssistantRightPane,
      };
    });
  };

  handleIsGeneratingAIResponse = isGeneratingAIResponse => {
    this.setState({ isGeneratingAIResponse });
  };

  toggleAITutorStudentPreviewModal = async () => {
    const {
      location,
      assessmentType,
      updateAIDataInRedux,
      updateQueryParameters,
      showAITutorStudentPreviewModal,
      taskTypeGroup,
    } = this.props;

    const target = _.get(location, "query.target");

    // once user closes the student preview modal, remove the ?target=sp query param (if present)
    if (
      showAITutorStudentPreviewModal &&
      target === "sp" &&
      (assessmentType === ASSESSMENT_TYPE_AI_TUTOR ||
        taskTypeGroup === TASK_TYPE_AI_TUTOR)
    ) {
      updateQueryParameters({
        paramsToBeRemoved: ["target"],
        navigateType: "replace",
      });
    }

    updateAIDataInRedux({
      showAITutorStudentPreviewModal: !showAITutorStudentPreviewModal,
    });
  };

  render() {
    const {
      props: {
        t,
        steps,
        isLocalisedTemplate,
        step_list,
        field_list,
        resourceFields,
        unitPlanFields,
        unitPlanTemplateFieldList,
        resourceId,
        totalCommentCount,
        unreadCommentCount,
        onClickPrint,
        updateField,
        parentType,
        removeAssessmentTool,
        subjects,
        grades,
        unitPlanTemplate,
        updateFieldInCache,
        isUnitPlanEditPermission,
        unitPlanId,
        renderAsComponent,
        portalType,
        sourceFrom,
        curriculumProgram,
        curriculumType,
        localisedTemplateId,
        warningMsg,
        assessmentType,
        taskTypeGroup,
        plannerElements,
        assessmentMode,
        assessmentTools,
        helpEnabledFields,
        mode,
        selectedCourseId,
        isUnitPlanTemplateLoading,
        templateId,
        isFromUnitPlan,
        unitType,
        creationMode,
        courseSubjects,
        testId = "resourceEdit",
        template,
        showAITutorStudentPreviewModal,
        ltiDropDownOptions,
        isFromInitializingModal,
        learningCourseId,
        curriculumProgramId,
        handleIsGeneratingAIResponse,
      },
      state: {
        fieldKey,
        showAssistantRightPane,
        missingCriteriaModalData,
        isGeneratingAIResponse,
      },
    } = this;

    const { currentRightPane, middlePaneRef } = this.state;

    const isEditPermission = isUnitPlanEditPermission({ unitPlanId });
    const showFooter =
      !renderAsComponent &&
      assessmentType !== ASSESSMENT_TYPE_AI_TUTOR &&
      taskTypeGroup !== TASK_TYPE_AI_TUTOR;

    const _assignmentTitle = getFieldValue({
      fields: resourceFields,
      uid: "title",
    });

    const assignmentTitle = !_.isEmpty(_assignmentTitle)
      ? _assignmentTitle
      : t("common:untitled");

    const containerClasses = classNames({
      [classes.container]: true,
      [classes.containerWithHeader]: !renderAsComponent,
    });

    return (
      <React.Fragment>
        {sourceFrom != "CLASSROOM" ? (
          <CoachMarks
            type={parentType}
            params={{ tabs: steps }}
            continuous={false}
          />
        ) : null}

        <div className={containerClasses} id={`COACHMARKS_${parentType}`}>
          {!_.isEmpty(missingCriteriaModalData)
            ? this.renderMissingCriteriaModal({
                t,
              })
            : null}
          {!renderAsComponent && (
            <Header
              onClickPrint={onClickPrint}
              parentType={parentType}
              onClose={this.onBack}
              unreadCommentCount={unreadCommentCount}
              totalCommentCount={totalCommentCount}
              onUnitSummaryClick={this.onUnitSummaryClick}
              onClickSave={this.onClickSave}
              onCommentClick={this.onCommentClick}
              isUnitSummaryActive={currentRightPane == "unitSummary"}
              isCommentActive={currentRightPane == "comment"}
              curriculumType={curriculumType}
              showPlannerOverview={!!unitPlanId}
              toggleAssignmentAIChat={this.toggleAssignmentAIChat}
              toggleAITutorStudentPreviewModal={
                this.toggleAITutorStudentPreviewModal
              }
              assessmentType={assessmentType}
              taskTypeGroup={taskTypeGroup}
              mode={mode}
              showSaveButton={!showFooter}
              testId={testId}
              assessmentId={resourceId}
              curriculumId={curriculumProgramId}
              isGeneratingAIResponse={isGeneratingAIResponse}
            />
          )}
          <div className={classes.bodyContainer}>
            <div className={classes.wrapperContainer}>
              <MiddlePane
                localisedTemplateId={localisedTemplateId}
                curriculumProgram={curriculumProgram}
                curriculumType={curriculumType}
                deleteAttachmentGroups={this.deleteAttachmentGroups}
                isLocalisedTemplate={isLocalisedTemplate}
                createAttachmentGroups={this.createAttachmentGroups}
                createAttachment={this.createAttachment}
                toggleFocusedField={this.toggleFocusedField}
                unitPlanTemplate={unitPlanTemplate}
                subjects={subjects}
                grades={grades}
                parentType={parentType}
                deleteAttachment={this.deleteAttachment}
                updateFieldInCache={updateFieldInCache}
                updateField={updateField}
                resourceId={resourceId}
                unitPlanFields={unitPlanFields}
                steps={steps}
                field_list={field_list}
                step_list={step_list}
                warningMsg={warningMsg}
                unitPlanTemplateFieldList={unitPlanTemplateFieldList}
                resourceFields={resourceFields}
                onClose={this.onBack}
                customRef={this.setMiddlePaneRef}
                unitPlanId={unitPlanId}
                portalType={portalType}
                readOnly={
                  !isEditPermission &&
                  ACLStore.can("TeacherPortal:ShowLeReadOnly")
                }
                assessmentType={assessmentType}
                taskTypeGroup={taskTypeGroup}
                plannerElements={plannerElements}
                assessmentTools={assessmentTools}
                removeAssessmentTool={removeAssessmentTool}
                mode={mode}
                assessmentMode={assessmentMode}
                currentFieldKey={fieldKey}
                onHelpClick={this.onHelpClick}
                currentRightPane={currentRightPane}
                helpEnabledFields={helpEnabledFields}
                sourceFrom={sourceFrom}
                selectedCourseId={selectedCourseId}
                isUnitPlanTemplateLoading={isUnitPlanTemplateLoading}
                templateId={templateId}
                unitType={unitType}
                middlePaneRef={middlePaneRef || this.middlePane}
                courseSubjects={courseSubjects}
                testId={testId}
                ltiDropDownOptions={ltiDropDownOptions}
                isFromInitializingModal={isFromInitializingModal}
                learningCourseId={learningCourseId}
                handleIsGeneratingAIResponse={
                  handleIsGeneratingAIResponse ||
                  this.handleIsGeneratingAIResponse
                }
              />
              {/* This will render Save button in footer when create / edit LE from unit plan */}
              {showFooter ? (
                <CompactUIFooter
                  renderAsComponent={false}
                  isFirstStep={true}
                  isLastStep={true}
                  onClickDone={this.onClickSave}
                  onClickCancel={this.onBack}
                  assessmentId={resourceId}
                />
              ) : null}
            </div>
            {this.renderRightPane()}

            <Transition
              isOpen={
                showAssistantRightPane &&
                getIsLessonPlanningEnabled(assessmentType, taskTypeGroup)
              }
              {...LESSON_PLANNING_TRANSITION_PROPS}
            >
              <LessonPlanningAssistant
                portalType={portalType}
                sourceFrom={sourceFrom}
                leId={resourceId}
                setShowAssistantRightPane={this.toggleAssignmentAIChat}
                mode={mode}
                middlePaneRef={this.middlePane}
                isFromUnitPlan={isFromUnitPlan}
                creationMode={creationMode}
                assessmentMode={assessmentMode}
                testId={"assessment-resourceEdit"}
                learningCourseId={learningCourseId}
              />
            </Transition>

            {showAITutorStudentPreviewModal ? (
              <ResourceDetailsContext.Consumer>
                {assessmentDetails => {
                  const { aiConversation, selectedCourseId } =
                    assessmentDetails || {};

                  const lastStudentPreviewConversation = _.findLast(
                    aiConversation?.edges,
                    ({ node }) => {
                      const { entitySubType } = node || {};
                      return (
                        entitySubType ===
                        initialStudentPreviewConversation.node.entitySubType
                      );
                    }
                  );

                  return (
                    <AITutorChatModal
                      assessmentId={resourceId}
                      entityId={resourceId}
                      conversationEntityType={"ASSESSMENT"}
                      onClose={this.toggleAITutorStudentPreviewModal}
                      courseId={selectedCourseId}
                      aiConversation={
                        lastStudentPreviewConversation ||
                        initialStudentPreviewConversation
                      }
                      assessmentDetails={assessmentDetails}
                      assessmentTemplate={template}
                      headerTitle={assignmentTitle}
                      source={"STUDENT_PREVIEW"}
                      learningCourseId={learningCourseId}
                      isValid={this.checkValidation}
                    />
                  );
                }}
              </ResourceDetailsContext.Consumer>
            ) : null}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapActionCreators = {
  updateField,
  createAttachment,
  deleteAttachment,
  toggleFocusedField,
  setToastMsg,
  removeAssessmentTool,
  isUnitPlanEditPermission,
  createAttachmentGroups,
  deleteAttachmentGroups,
  updateAssessmentInRedux,
  updateShowAIQuickTip,
  updateAIDataInRedux,
  updateQueryParameters,
  validateAIEvaluationEligibility,
  updateNavigationObject,
};

const mapStateToProps = (state, ownProps) => {
  const {
    t,
    template: originalTemplate,
    unitPlanTemplate,
    sourceFrom,
    assessmentType,
    taskTypeGroup,
    resourceFields,
    templateId,
    subjects,
    courseSubjects,
    isFromInitializingModal,
    learningCourseId,
    coursePrimaryGradeId,
  } = ownProps;

  const aiData = _.get(state, "assessment.aiData", {});
  const showAITutorStudentPreviewModal = _.get(
    aiData,
    "showAITutorStudentPreviewModal",
    false
  );

  const activeTab = state.login.activeTab;
  const isToddleLibrary = activeTab == TODDLE_LIBRARY;

  const curriculumType =
    (isToddleLibrary
      ? _.get(state, "classRoom.curriculumProgram.type", "")
      : getCurrentCurriculumProgramType(state)) ||
    _.get(ownProps, "curriculumType");

  const curriculumProgramVariant = _.get(
    getSelectedCurriculumProgram(state),
    "variant"
  );

  let isFromClassroom = getIsFromClassroom({
    sourceFrom,
    template: originalTemplate,
  });

  const academicYearId = getSelectedAcademicYearId(state);
  const curriculumProgramId = getSelectedCurriculumId(state);
  const isCourseBasedGrading = getIsCourseBasedGradingEnabled();
  const isUsingNewGradingSetupInCourses = getIsConfigurationEnabledForCPAY({
    configuration: USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
    curriculumProgramId,
    academicYearId: academicYearId,
  });

  const assessmentSubjectIds =
    _.find(resourceFields, { uid: "subjects" })?.value || [];

  const template = updateAssessmentTemplate({
    t,
    template: originalTemplate,
    assessmentType,
    taskTypeGroup,
    isFromClassroom,
    curriculumType,
    resourceFields,
    mode: "edit",
    templateId,
    plannerElementSets: _.get(state, "platform.currentPlannerElementSets", []),
    subjects: !_.isEmpty(subjects) ? subjects : courseSubjects,
    userType: getUserType(state),
    assessmentTools: _.get(ownProps, "assessmentTools", []),
    learningCourseId,
    coursePrimaryGradeId,
    assessmentSubjectIds,
    isCourseBasedGrading,
    isUsingNewGradingSetupInCourses,
    sourceFrom,
  });

  isFromClassroom = getIsFromClassroom({ sourceFrom, template });

  let steps = isFromInitializingModal
    ? _.get(template, "initialCreateSteps", [])
    : isFromClassroom
    ? _.get(template, "classroomEditSteps", [])
    : _.get(template, "steps", []);

  if (
    _.isEqual(assessmentType, ASSESSMENT_TYPE_WORKSHEET) ||
    _.isEqual(taskTypeGroup, TASK_TYPE_WORKSHEET)
  ) {
    steps = _.without(steps, "maximumScore", []);
  }

  const step_list = _.get(template, "step_list", {});
  const field_list = _.get(template, "field_list", {});

  const aiTutorSelectedTab = _.get(
    state,
    "assessment.aiData.aiTutorSelectedTab"
  );

  const isLearningCoursesEnabled = getIsLearningCoursesEnabled();

  // when learning course is enabled, right pane automatically opens
  // through AddAssignment component
  const openAIAssistantOnMount =
    !isLearningCoursesEnabled &&
    _.get(state, "unitFlow.openAssessmentAIPaneOnMount", false);

  const showAssessmentCommentBox = _.get(
    state,
    "navigation.navigationObject.showAssessmentCommentBox"
  );

  return {
    step_list,
    field_list,
    steps,
    localisedTemplateId: _.get(template, "localisedTemplateId", ""),
    unitPlanTemplateFieldList: _.get(unitPlanTemplate, "field_list", {}),
    isLocalisedTemplate: _.get(template, "isLocalisedTemplate", true),
    unitPlanTemplate,
    originalTemplate,
    template,
    curriculumProgramVariant,
    courseSubjects,
    showAITutorStudentPreviewModal,
    aiTutorSelectedTab,
    openAIAssistantOnMount,
    showAssessmentCommentBox,
    curriculumProgramId,
  };
};

export default compose(
  I18nHOC({ resource: ["unitPlan", "common", "unitPlanTemplate"] }),
  connect(mapStateToProps, mapActionCreators)
)(ResourceEdit);
